import React from 'react';

const KanbanBoard = () => {
  return <div>KanbanBoard is under construction.</div>;
};

export default KanbanBoard;
